<template>
    <div
        class="flex flex-wrap items-center justify-center"
        :class="isDesktop ? 'gap-6' : 'gap-3'"
    >
        <component
            :is="item.href ? 'a' : 'div'"
            v-for="item in items"
            :key="item.key"
            v-bind="linkAttrs(item)"
            :aria-label="item.title"
            class="relative flex max-w-19rem overflow-hidden rounded-xl bg-stack-text shadow-md no-underline"
            :class="isDesktop ? 'h-56 w-80' : 'h-40 w-full'"
            @click="onClick"
        >
            <img
                v-if="item.imageUrl"
                :src="item.imageUrl"
                :alt="item.imageAlt"
                class="absolute inset-0 h-full w-full object-cover"
            />
            <div v-else class="absolute inset-0">
                <slot name="placeholder" :item="item"></slot>
            </div>
        </component>
    </div>
</template>

<script>
export default {
    name: "SliderV6",
    props: {
        items: { type: Array, required: true },
        previewOnly: { type: Boolean, default: false },
        isDesktop: { type: Boolean, default: true }
    },
    methods: {
        linkAttrs(item) {
            return item.href
                ? { href: item.href, target: item.target, rel: item.rel }
                : {};
        },
        onClick(event) {
            if (this.previewOnly) event.preventDefault();
        }
    }
};
</script>
